(() => {
  'use strict';
  if (window.__kmCartDrawerPairRecommendations) return;

  const events = ['cart:rendered', 'cart:updated', 'ajaxProduct:added', 'drawerOpen.CartDrawer'];
  let drawer = null;
  let activeContext = null;
  let lastAnchor = null;
  let suppressDefault = false;
  let cleanup = null;
  let view = null;
  const media = window.matchMedia('(min-width: 769px)');

  const isGift = line => line.hasAttribute('data-km-gift-line-item');
  const contextFor = line => ({
    productId: line.dataset.kmCartProductId || '',
    variantId: line.dataset.kmCartVariantId || ''
  });
  const sameContext = (left, right) => Boolean(left && right)
    && left.productId === right.productId && left.variantId === right.variantId;

  function setOpen(line, open) {
    const toggle = line.querySelector('[data-km-cart-pair-toggle]');
    const panel = line.querySelector('[data-km-cart-pair-inline]');
    if (!toggle || !panel) return;
    line.classList.toggle('km-cart-line-item--pair-open', open);
    panel.classList.toggle('is-open', open);
    panel.setAttribute('aria-hidden', String(!open));
    panel.inert = !open;
    toggle.setAttribute('aria-expanded', String(media.matches ? line.classList.contains('km-cart-line-item--selected') : open));
  }

  function sync() {
    if (!drawer) return;
    const lines = [...drawer.querySelectorAll('[data-km-cart-line]')]
      .filter(line => !isGift(line) && line.querySelector('[data-km-cart-pair-toggle]'));
    const matchingLine = lines.find(line => sameContext(contextFor(line), activeContext))
      || lines.find(line => contextFor(line).productId === activeContext?.productId)
      || null;
    const selected = matchingLine || (suppressDefault ? null : lines[0]) || null;
    activeContext = selected ? contextFor(selected) : null;
    if (selected) lastAnchor = activeContext;
    lines.forEach(line => setOpen(line, line === selected));
    if (!drawer.classList.contains('drawer--is-open')) return;
    const desktopLine = lines.find(line => line.classList.contains('km-cart-line-item--selected'));
    const line = media.matches ? desktopLine : selected;
    const target = media.matches ? drawer.querySelector('[data-km-cart-pair]') : line?.querySelector('[data-km-cart-pair-inline]');
    if (!line || !target) { view?.cancel(); return; }
    const handle = line.dataset.kmCartProductHandle;
    if (!media.matches) drawer.dispatchEvent(new CustomEvent('km:cart-mobile-pair-context', {detail: {line}}));
    view?.render(target, handle);
  }

  function init() {
    const nextDrawer = document.getElementById('CartDrawer');
    if (!nextDrawer || nextDrawer === drawer) {
      sync();
      return;
    }
    cleanup?.();
    drawer = nextDrawer;
    view = window.KMCartPairView?.create(drawer);

    const onClick = event => {
      const retry = event.target.closest?.('[data-km-pair-list-retry]');
      if (retry && drawer.contains(retry)) {
        event.preventDefault();
        view?.reset(retry.closest('[data-km-cart-pair], [data-km-cart-pair-inline]'));
        sync();
        return;
      }
      const toggle = event.target.closest?.('[data-km-cart-pair-toggle]');
      if (!toggle || !drawer.contains(toggle) || window.matchMedia('(min-width: 769px)').matches) return;
      event.preventDefault();
      const line = toggle.closest('[data-km-cart-line]');
      if (!line || isGift(line)) return;
      const isOpen = line.querySelector('[data-km-cart-pair-inline]')?.classList.contains('is-open');
      const anchorChanged = !isOpen && !sameContext(lastAnchor, contextFor(line));
      suppressDefault = isOpen;
      activeContext = isOpen ? null : contextFor(line);
      sync();
      if (anchorChanged && sameContext(activeContext, contextFor(line))) {
        window.KMCartAnalytics?.trackProduct('select_cart_anchor_item', line);
      }
    };
    const onUpdate = event => {
      if (event.detail?.location && event.detail.location !== 'cart-drawer') return;
      requestAnimationFrame(sync);
    };

    drawer.addEventListener('click', onClick);
    drawer.addEventListener('km:cart-pair-context', sync);
    events.forEach(name => document.addEventListener(name, onUpdate));
    window.addEventListener('garage:select', sync);
    window.addEventListener('garage:remove', sync);
    window.addEventListener('storage', sync);
    window.addEventListener('pageshow', sync);
    document.addEventListener('km:mobile-ride-storage-change', sync);
    media.addEventListener('change', sync);
    const observer = new MutationObserver(sync);
    observer.observe(drawer, {attributes: true, attributeFilter: ['class']});
    cleanup = () => {
      view?.destroy();
      observer.disconnect();
      drawer?.removeEventListener('click', onClick);
      drawer?.removeEventListener('km:cart-pair-context', sync);
      events.forEach(name => document.removeEventListener(name, onUpdate));
      window.removeEventListener('garage:select', sync);
      window.removeEventListener('garage:remove', sync);
      window.removeEventListener('storage', sync);
      window.removeEventListener('pageshow', sync);
      document.removeEventListener('km:mobile-ride-storage-change', sync);
      media.removeEventListener('change', sync);
    };
    sync();
  }

  window.__kmCartDrawerPairRecommendations = {init};
  document.addEventListener('DOMContentLoaded', init, {once: true});
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', event => {
    if (drawer && event.target?.contains?.(drawer)) cleanup?.();
  });
  init();
})();
